import axios from 'axios'

const couchDB = axios.create({
  baseURL: 'https://c4fitness.lk:4984',
  auth: {
    username: 'admin',
    password: 'c4@123',
  },
})

export const state = {
  authDetails: getSavedState('auth.authDetails'),
}

export const mutations = {
  SET_AUTH_DETAILS(state, newValue) {
    state.authDetails = newValue
    saveState('auth.authDetails', newValue)
    setDefaultAuthHeaders(state)
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.authDetails
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
    dispatch('validate')
  },
  // Logs in the current user.
  async logIn({ commit, dispatch, getters }, { email, password } = {}) {
    try {
      const response = await couchDB.post('/c4_db/_find', {
        selector: {
          type: 'user',
          email: email,
          password: password,
        },
        limit: 10000000,
      })

      if (response.data.docs.length > 0) {
        // commit('SET_AUTH_DETAILS', response.data.docs[0])
        localStorage.setItem('userType', response.data.docs[0].user_type)
        return response.data
      } else {
        return false
      }
    } catch (error) {
      throw error
    }

    // if (getters.loggedIn) return dispatch('validate')
    // return axios
    //   .post('v1/auth/validateUser', { email, password })
    //   .then(response => {
    //     const authDetails = response.data
    //     commit('SET_AUTH_DETAILS', authDetails)
    //     return authDetails
    //   })
  },
  // Logs out the current user.
  logOut({ commit }) {
    commit('SET_AUTH_DETAILS', null)
  },
  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state }) {
    if (!state.authDetails) return Promise.resolve(null)

    return axios
      .get('v1/auth/verifyToken', {
        headers: {
          Authorization: `Bearer ${state.authDetails.accessToken}`,
        },
      })
      .then(response => {
        const authDetails = state.authDetails
        commit('SET_AUTH_DETAILS', authDetails)
        return authDetails
      })
      .catch(error => {
        if (error.response.status === 401) {
          commit('SET_AUTH_DETAILS', null)
        }
        return null
      })
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.common.Authorization = state.authDetails
    ? state.authDetails.token
    : ''
}
